export default __webpack_public_path__ + "static/resources/policy/Политика_в_области_соблюдения_прав_человека.doc";